import(/* webpackMode: "eager", webpackExports: ["ArticlePage"] */ "/home/runner/work/shipsmart-frontend/shipsmart-frontend/apps/admin/src/app/shared/landing/pages/news/article-page.tsx");
